.activityLine {
  align-items: center;
  border-top: 1px solid var(--comp-activityfeed-border-color);
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  padding: var(--space-medium);
  transition: background-color .3s ease-in-out;
}

.activityLine:hover {
  background-color: rgb(0 0 0 / 2.5%);

}

.activityLine:nth-child(1) {
  border-top: 0 solid transparent;
}

.avatar {
  --avatar-size: 40px;

  display: inline-block;
  margin-right: var(--space-medium);
  position: relative;
  vertical-align: middle;
}

.activityMessage {
  font-size: var(--font-size-6);
}

.date {
  font-size: var(--font-size-7);
  font-style: italic;
  min-width: 150px;
  text-align: right;
}

.activityMessage,
.activityMessage *,
.date,
.date * {
  color: var(--comp-card-color);
}

.isScrollable {
  max-height: 300px;
  overflow-y: scroll !important;
}

.isRead {
  opacity: 0.6;
}

@media screen and (width <=650px) {
  .avatar {
    --avatar-size: 20px;
  }

  .activityLine {
    align-items: flex-start;
    flex-direction: column-reverse;
  }

  .date {
    align-self: flex-end;
  }
}